export const UnassignmentSource = {
  NotSet: 0,
  Manual: 1,
  Synchronization: 2,
  Rescheduling: 3,
  ReviewDate: 4,
  AutoUnallocation: 5,
  PostcodeChange: 6,
  ActivityChange: 7,
  MasterUnallocated: 8,
  UnitChange: 9,
  OverrideBand: 10,
};
